// React
import React, { useEffect } from "react";
// React
// CSS
import styles from "./TeacherShower.module.css";
import { I_Teacher } from "../../../Models/interfaces";
import { Link, useNavigate } from "react-router-dom";
import { _stringify } from "../../../Utils/_stringify";
// CSS

type TeacherShowerProps = {
  teachers: I_Teacher[];
  isTeachersPending: boolean;
  isGlobalTeacher: boolean;
  state: any;
};

const TeacherShower: React.FunctionComponent<TeacherShowerProps> = ({
  isTeachersPending,
  teachers,
  isGlobalTeacher,
  state,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!state) {
      navigate("/");
      return;
    }
  }, [navigate, state]);

  const setterToLocalStorage = (teacherId: any, teacherName: any) => {
    const teacherIdStr = _stringify(teacherId);
    const teacherNameStr = _stringify(teacherName);
    localStorage.setItem("teacherId", teacherIdStr);
    localStorage.setItem("teacherName", teacherNameStr);
  };

  return (
    <div className={`${styles.teacherShowerContainer} w-full`}>
      {" "}
      {isTeachersPending ? (
        <p className="w-full text-center pt-4">در حال بارگذاری</p>
      ) : (
        teachers
          .filter((item) => Boolean(item.is_global) !== isGlobalTeacher)
          .map((item) => (
            <Link
              to={`/teacher/${item.teacher_id}`}
              state={{ ...state, teacherData:item}}
              key={item.id}
              className={`${styles.teacherLink} w-full text-center mt-4 py-2 rounded-xl text-sm`}
              onClick={() => {
                setterToLocalStorage(item.teacher_id, item.fullName);
              }}
            >
              {item.fullName}
            </Link>
          ))
      )}
    </div>
  );
};

export default TeacherShower;
